import LoginForm from "../../Components/Login/LoginForm";
import "../../Components/Login/LoginForm.css";
import { Link } from "react-router-dom";

const Login = () => {
  return (
    <>
      <div className="login-container-bg">
        <div className="login-container">
          <LoginForm />
          <div className="login-links">
            <div>Need an Account?</div>
            <div>
              <Link to="/register">Register with MAST</Link>
            </div>
          </div>
          <div className="login-links">
            <div>
              If you have registered with myServiceTas and linked your MAST account, you can sign in from {" "}
              <a
                href={process.env.REACT_APP_MYSERVICETAS_RETURN_URL || "https://portal.my.service.tas.gov.au"}
                className="login-myservicetas-link"
              >
                there
              </a>
              .
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
